const SUCCESS = 'text-success-default';
const CRITICAL = 'text-critical-default';
const NEUTRAL = 'text-neutral-default';

/**
 * Prism colour class for a metric's change vs its comparison. Magnitudes within
 * `neutralThreshold` are neutral; `invert` flips success/critical for
 * "lower is better" metrics (e.g. cost).
 */
export function deltaColorClass(
  value: number,
  {
    invert = false,
    neutralThreshold = 0,
  }: { invert?: boolean; neutralThreshold?: number } = {},
): string {
  if (Math.abs(value) <= neutralThreshold) {
    return NEUTRAL;
  }
  return value > 0 !== invert ? SUCCESS : CRITICAL;
}
